export default __webpack_public_path__ + "static/media/tracking_banner1.f6503596.jpg";